import axiosInstance from "../../api/axios";

const CatalogSyncIssuesService = {
  getIssues: async (options = {}) => {
    const params = new URLSearchParams();
    if (options.status) params.set("status", options.status);
    if (options.type) params.set("type", options.type);
    if (options.limit) params.set("limit", String(options.limit));
    const query = params.toString();
    const url = query
      ? `/monitoring/catalog-sync-issues?${query}`
      : "/monitoring/catalog-sync-issues";
    const response = await axiosInstance.get(url, { timeout: 60000 });
    return response.data;
  },

  getEntity: async ({ entityType = "product", redId, id } = {}) => {
    const params = new URLSearchParams();
    params.set("entity_type", entityType);
    if (redId != null && redId !== "") params.set("red_id", String(redId));
    if (id != null && id !== "") params.set("id", String(id));
    const response = await axiosInstance.get(
      `/monitoring/catalog-sync-issues/entity?${params.toString()}`,
      { timeout: 30000 }
    );
    return response.data;
  },

  acknowledge: async (id) => {
    const response = await axiosInstance.post(
      `/monitoring/catalog-sync-issues/${id}/acknowledge`
    );
    return response.data;
  },

  confirmSame: async (id, { force = false } = {}) => {
    const response = await axiosInstance.post(
      `/monitoring/catalog-sync-issues/${id}/confirm-same`,
      { force: force ? 1 : 0 }
    );
    return response.data;
  },

  scan: async () => {
    const response = await axiosInstance.post(
      "/monitoring/catalog-sync-issues/scan"
    );
    return response.data;
  },
};

export default CatalogSyncIssuesService;
